import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { StoreService } from './store.service';
import { environment } from '@env';

@Injectable({ providedIn: 'root' })
export class TitleSyncService {
  private readonly base = 'FreshAi';

  constructor(title: Title, store: StoreService) {
    store.storeId$.subscribe((id) => {
      const suffix = id ? ` [${environment.name}] • ${id}` : '';
      title.setTitle(this.base + suffix);
    });
  }
}
